const QuickLinksSchema = () => ({
  title: 'AgSUS Acesso à informação',
  fieldsets: [
    {
      id: 'default',
      title: 'Seção',
      fields: ['title', 'description', 'variant', 'items'],
    },
  ],
  properties: {
    title: { title: 'Título (opcional)' },
    description: { title: 'Subtítulo (opcional)' },
    variant: {
      title: 'Variação visual',
      choices: [
        ['default', 'Padrão'],
        ['panel', 'Painel cinza'],
      ],
      default: 'default',
    },
    items: {
      title: 'Links',
      description: 'Adicione, edite e reordene os links pela barra lateral.',
      widget: 'object_list',
      schema: {
        title: 'Link',
        fieldsets: [
          {
            id: 'default',
            title: 'Default',
            fields: ['label', 'sublabel', 'href'],
          },
        ],
        properties: {
          label: { title: 'Rótulo' },
          sublabel: { title: 'Sub-rótulo' },
          href: { title: 'Endereço' },
        },
        required: ['label'],
      },
    },
  },
  required: [],
});
export default QuickLinksSchema;
